<template>
  <div>
    <UserSetPopup
      :userSetPopFlag="userSetPopFlag"
      @closeUserSet="closeUserSet"
    />
    <header class="box__shadow__01">
      <div class="header__inner">
        <nav class="header__inner__left">
          <h1>
            <a href="#">
              <img
                src="@/assets/images/newlogo.svg"
                alt="범용적인 디지털치료기기 플랫폼 로고"
              />
            </a>
          </h1>
          <ul>
            <li
              v-for="menu in userMenus"
              :key="menu.menuNm"
              :class="'len' + menu.subMenu.length"
            >
              <router-link
                :to="menu.link"
                :class="{ on: basePath === menu.basePath }"
                >{{ menu.menuNm }}</router-link
              >
              <ul>
                <li v-for="subMenu in menu.subMenu" :key="subMenu.menuNm">
                  <router-link :to="subMenu.link" active-class="on">
                    {{ subMenu.menuNm }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <div class="header__inner__right">
          <ul>
            <li class="fullscreen__icon" @click="fullScrennToggle">
              <img
                v-if="!fullScreenFlag"
                src="@/assets/images/icon/ic_fullscreen_off.svg"
                alt="풀스크린 off 아이콘"
              />
              <img
                v-else
                src="@/assets/images/icon/ic_fullscreen_on.svg"
                alt="풀스크린 on 아이콘"
              />
            </li>
            <li class="notice__icon">
              <label class="notice__label" for="nofifocusCheck">
                <input type="text" id="nofifocusCheck" />
                <img
                  src="@/assets/images/icon/ic_notice.svg"
                  alt="알림 아이콘"
                />
                <dl class="notification__box box__shadow__01">
                  <dt>
                    <h5>모든 알림</h5>
                    <p class="count f__bold">{{ testMsgData.length }}</p>
                  </dt>
                  <dd>
                    <ul class="notification__list__wrap vertical__scroll">
                      <!-- item -->
                      <li v-for="(item, idx) in testMsgData" :key="idx">
                        <p>{{ item.content }}</p>
                        <dl>
                          <dt>{{ item.userName }}</dt>
                          <dd>{{ item.updateTime }}</dd>
                        </dl>
                      </li>
                      <!-- // item -->
                    </ul>
                  </dd>
                </dl>
              </label>
            </li>
          </ul>
          <label class="user__profile" for="focusCheck">
            <input type="text" id="focusCheck" />
            <img
              src="@/assets/images/icon/ic-user.svg"
              alt="로그인 유저 프로필 사진"
            />
            <dl>
              <dt class="f__bold">{{ userName }}</dt>
              <dd class="f__bold">{{ userDept }}</dd>
            </dl>
            <div class="login__hover__box box__shadow__01">
              <dl>
                <dt class="f__bold">{{ userName }}</dt>
                <dd class="f__bold">{{ userDept }}</dd>
              </dl>
              <ul>
                <li>
                  <button @click="userSetClick()">
                    <span class="icon">
                      <img
                        src="@/assets/images/icon/ic_profile_1.svg"
                        alt="내정보 수정 아이콘 "
                      />
                    </span>
                    <dl>
                      <dt>내 정보 수정</dt>
                      <dd>개인 정보를 수정합니다.</dd>
                    </dl>
                  </button>
                </li>
              </ul>
              <div class="bottom">
                <button class="custom__btn" @click="logoutBtnClick()">
                  <p>로그아웃</p>
                </button>
              </div>
            </div>
          </label>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import { transformToMenuTree } from "@/utill/commom";
import UserSetPopup from "@/components/common/UserSetting";
import sha256 from "sha256";
import { getSimpleUserInfo } from "@/utill/auth";
export default {
  watch: {
    $route() {
      this.setBasePath();
    },
  },
  components: {
    UserSetPopup,
  },
  name: "Common-Header",
  data() {
    return {
      userName: "",
      userDept: "",
      basePath: "",
      fullScreenFlag: false,
      userFunctions: [],
      userMenus: [],
      userSetPopFlag: false,
      testMsgData: [
        {
          content: "3일동안 단주체크를 하지 않으셨습니다.",
          userName: "홍길동",
          updateTime: "2021-10-20 11:30:00",
        },
        {
          content: "7일동안 치료내역이 없습니다.",
          userName: "김길동",
          updateTime: "2021-10-20 11:30:00",
        },
        {
          content: "금주 치료내역이 없습니다.",
          userName: "박길동",
          updateTime: "2021-10-20 11:30:00",
        },
      ],
    };
  },
  created() {
    // 사용자 프로필 설정
    this.$store.dispatch("getUserInfo").then((userDetail) => {
      this.userName = userDetail.name;
      this.userDept = userDetail.deptName;
    });
    // 사용자 소유한 모든 기능 조회
    /*if (this.$store.getters.getUserFunctions.length === 0) {
      this.$store.dispatch("getUserFunctions").then((userFunctions) => {
        this.userFunctions = userFunctions;
      });
    } else {
      this.userFunctions = this.$store.getters.getUserFunctions;
    }*/

    //this.userMenus = this.$store.getters.getUserMenus;
    this.getUserMenuList();
    /*if (this.$store.getters.getUserMenuTree.length === 0) {
      this.$store.dispatch("createUserMenuTree").then((userMenus) => {
        this.userMenus = userMenus;
      });
    } else {
      this.userMenus = this.$store.getters.getUserMenuTree;
    }*/
  },
  mounted() {
    window.addEventListener("resize", this.screenResize);
    this.setBasePath();
  },
  methods: {
    userSetClick() {
      const simpleUserInfo = JSON.parse(getSimpleUserInfo());
      this.$confirm({
        auth: true,
        message: "현재 비밀번호를 입력해주세요",
        button: {
          no: "취소",
          yes: "확인",
        },
        callback: (confirm, password) => {
          if (confirm && sha256(password) === simpleUserInfo.userPassword) {
            this.userSetPopFlag = true;
          } else {
            this.$toast.error("비밀번호가 잘못되었습니다.");
          }
        },
      });
    },
    closeUserSet() {
      this.userSetPopFlag = false;
    },
    setBasePath() {
      this.basePath = this.$route.fullPath.split("/")[1];
    },
    // 사용자 접속가능한 메뉴 생성
    getUserMenuList() {
      // 전체 메뉴 조회 후, 사용자 소유한 모든 기능과 메뉴에 매칭된 기능을 비교하여 메뉴 트리 생성
      let allMenus =
        this.$store.state.system.systemManagement.adminMenuManagement;
      //let allMenus = [];
      let parents = [];
      let children = [];
      allMenus.forEach(function (menu) {
        menu.subMenu = [];
        if (menu.menuHighId === "") {
          parents.push(menu);
        }
      });
      children = allMenus.filter(function (menu) {
        return menu.menuHighId !== "";
      });
      transformToMenuTree(parents, children);
      if (this.$env == "development") console.log(parents);
      this.userMenus = parents;
    },
    async logout() {
      await this.$store.dispatch("logout");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    logoutBtnClick() {
      this.$confirm({
        // showCancelButton: true,
        title: "확인",
        message: "로그아웃 하시겠습니까?",
        button: {
          no: "아니오",
          yes: "네",
        },
        callback: (confirm) => {
          if (confirm) {
            this.logout();
          }
        },
      });
    },
    fullScrennToggle() {
      if (!this.fullScreenFlag) {
        document.documentElement.requestFullscreen();
        this.fullScreenFlag = true;
      } else {
        document.exitFullscreen();
        this.fullScreenFlag = true;
      }
    },
    screenResize() {
      if (
        screen.width === window.innerWidth &&
        screen.height === window.innerHeight
      ) {
        this.fullScreenFlag = true;
      } else {
        this.fullScreenFlag = false;
      }
    },
  },
};
</script>
